module.exports = __webpack_public_path__ + "img/carrito.c153ec79.png";